import styled from 'styled-components'

export const WrapperCalendar = styled.div`
    height: 100%;
    .rbc-allday-cell,
    .rbc-month-header {
        display: none;
    }
    .rbc-day-slot .rbc-events-container {
        margin-right: 0;
    }
    /* Месяц календарь */
    .rbc-month-view {
        border-radius: 8px;
        border: 1px solid #e1e4ea;
        overflow: hidden;
        .rbc-day-bg {
            border-left: 1px solid #e1e4ea;
        }
        .rbc-off-range-bg {
            background: #f6f9ff;
        }
        .rbc-date-cell {
            text-align: left;
            padding-right: 0;
            padding-left: 12px;
            padding-top: 12px;
            display: flex;
            .rbc-button-link {
                color: #282a42;
                font-size: 10px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
            }
        }
        .rbc-off-range {
            .rbc-button-link {
                color: #8181a5;
            }
        }
        .rbc-today {
            background: #f6f9ff;
        }
        .rbc-show-more {
            color: #34bd93;
            font-size: 12px;
            font-family: 'Inter', sans-serif;
            font-weight: 600;
        }
    }
    /* Конец месяца календаря */

    .rbc-time-view {
        border: none;
        border-right: 1px solid #e1e4ea;
        border-radius: 8px 8px 0 0;
        overflow: hidden;
    }
    .rbc-time-view-resources {
        display: grid !important;
        grid-template-rows: max-content 1fr !important;
    }
    .rbc-time-view-resources .rbc-label.rbc-time-header-gutter {
        background-color: #e1e4ea;
    }
    .rbc-time-header-content > .rbc-row.rbc-row-resource {
        border-bottom: none;
    }
    .rbc-time-header-content {
        border-left: 1px solid #e1e4ea;
    }
    .rbc-current-time-indicator {
        display: none;
    }
    .rbc-time-header {
        border: none;
        background-color: #e1e4ea;
        border-radius: 8px 8px 0 0;
        .rbc-time-header-gutter {
            min-width: 64px !important;
            max-width: 64px !important;
        }
        .rbc-header {
            border: none;
            color: #282a42;
            text-align: center;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            padding: 6px 0;
        }
    }
    .rbc-today {
        background: inherit;
    }
    .rbc-time-content {
        overflow-x: auto;
        scroll-behavior: smooth;
        border: none;
        .rbc-time-gutter {
            .rbc-timeslot-group {
                min-width: 64px !important;
                max-width: 64px !important;
                border-bottom: 1px solid #e1e4ea !important;
                border-left: none !important;

                .rbc-time-slot {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                span {
                    color: #1c1d21;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 18px;
                }
            }
        }
        .rbc-time-column {
            .rbc-timeslot-group {
                border-left: 1px solid #e1e4ea;
                border-bottom: 1px solid #e1e4ea;
            }
        }
    }
    .rbc-event:focus {
        outline: none !important;
    }

    .blocked {
        cursor: default;
        pointer-events: none;
        background: #e1e4ea;
        opacity: 0.75;
        color: #282a42;
        border: none;
        border-radius: 0;
    }
    
    .blocked-by-area-policy {
        cursor: default;
        pointer-events: none;
        background: repeating-linear-gradient(
            45deg,
            #e1e4ea,
            #e1e4ea 8px,
            #d4d8e0 8px,
            #d4d8e0 16px
        );
        opacity: 0.5;
        color: #282a42;
        border: none;
        border-radius: 0;
        
        .rbc-event-label {
            display: none;
        }
        .rbc-event-content {
            display: none;
        }
    }
`

export const EVENT_THEME = {
    DEFAULT: {
        background: '#e3f8ef',
        color: '#34bd93',
        borderColor: 'transparent',
        borderLeft: '3px solid #34bd93',
    },
    UNPAID: {
        background: '#FDECEC',
        color: '#B42318',
        borderColor: 'transparent',
        borderLeft: '3px solid #34bd93',
    },
    PARTIALLY_PAID: {
        background: '#FFF7E6',
        color: '#B58105',
        borderColor: 'transparent',
        borderLeft: '3px solid #34bd93',
    },
    EDIT: {
        background: '#fae1c1',
        color: '#bd7234',
        borderColor: 'transparent',
        borderLeft: '3px solid #bd7234',
    },
    NEW: {
        background: '#e3e6f8',
        color: '#4557ab',
        borderColor: 'transparent',
        borderLeft: '3px solid #4557ab',
    }
}